module.exports = __webpack_public_path__ + "school/img/campus_health_detail_top_bg.2b8fc1fb.png";